import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row, Typography } from 'seagull';
import { InvoiceAccountingIntegrationStatus } from '~/components/InvoiceAccountingIntegrationStatus';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { Accounting } from '~/types/api.model';
export const displayStatusToSkin = {
    issued: undefined,
    pending: undefined,
    overdue: 'error',
    processing: 'success',
    paid: 'success',
    voided: undefined,
    refunded: 'standard',
    refundFailed: 'error',
    disputed: 'error',
    partiallyRefunded: 'standard'
};
export function InvoiceNumberCell(param) {
    let { invoice, testId, numberSkin, numberClassName } = param;
    const showQboIntegration = useStore(selectors.integration.showQboIntegration);
    const showXeroIntegration = useStore(selectors.integration.showXeroIntegration);
    return /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 8,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: "".concat(testId, "-invoice-no"),
                skin: numberSkin,
                className: numberClassName,
                children: invoice.formattedNumber
            }),
            showQboIntegration && /*#__PURE__*/ _jsx(InvoiceAccountingIntegrationStatus, {
                testId: "".concat(testId, "-qbo"),
                invoiceIntegration: invoice.integration,
                accountingType: Accounting.QBO
            }),
            showXeroIntegration && /*#__PURE__*/ _jsx(InvoiceAccountingIntegrationStatus, {
                testId: "".concat(testId, "-xero"),
                invoiceIntegration: invoice.xeroIntegration.getIntegration(),
                accountingType: Accounting.Xero
            })
        ]
    });
}
